/**
 * Not found page.
 *
 * Reached for an unknown route and for an unknown share token, so it offers both
 * ways back: the home page and the user's own event list.
 */

import { Link } from 'react-router'
import { useTranslation } from 'react-i18next'

import { Button } from '../components/ui/button'
import { EmptyState } from '../components/ui/primitives'

export function NotFoundPage() {
  const { t } = useTranslation()

  return (
    <div className="container-narrow">
      <EmptyState
        className="mt-8"
        title={t('common.notFound')}
        description={t('error.not_found')}
        action={
          <div className="flex gap-2 pt-2">
            <Button asChild>
              <Link to="/">{t('nav.home')}</Link>
            </Button>
            <Button variant="outline" asChild>
              <Link to="/me">{t('nav.me')}</Link>
            </Button>
          </div>
        }
      />
    </div>
  )
}
